/**
 * @file: isTV.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import type { PresentationMode } from '@euler/app/components/PresentationModeContext';
import { config } from '@euler/config';
import { kPreferredPresentationModeKey } from '@euler/functions/constants';
import { isMobileBrowser } from '@euler/functions/responsiveness';
import { asyncStorageSubjectForKey$ } from '@euler/functions/useAsyncStorage';
import { useBehaviorSubject } from '@euler/utils/hooks';
import { Platform } from 'react-native';

export const isHubBuild = () => config.target === 'tv';

export const preferredPresentationMode$ =
  asyncStorageSubjectForKey$<PresentationMode>(
    kPreferredPresentationModeKey,
    isHubBuild() ? 'presentation' : undefined,
  );

export const useIsHub = () => {
  const [mode] = useBehaviorSubject(preferredPresentationMode$);
  return (
    !isMobileBrowser() &&
    (mode === 'presentation' || Platform.isTV || isHubBuild())
  );
};

export const isHubMode = () =>
  !isMobileBrowser() &&
  (preferredPresentationMode$.value === 'presentation' ||
    Platform.isTV ||
    isHubBuild());
